import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import VideoRowItem from './VideoRowItem'
import LargeVideoPreviewBox from './LargeVideoPreviewBox'
import useStyles from './styles/SectionThreeItemsStyle'

class SectionThreeItems extends Component {
  constructor(props) {
    super(props)
    this.state = {
      windowWidth: window.innerWidth,
    }
    // bind functions to 'this' instance:
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    // the handleResize method will be invoked every time the window will get resized
    window.addEventListener('resize', this.handleResize);
  }

  // This method is invoked every time the window is resized.
  handleResize() {
    this.setState({
      windowWidth: window.innerWidth,
    })
  }

  getLargeVideoPreviewBoxHeight() {
    // As every section, this section has 10px padding from the left and from the right.
    const boxWidth = this.state.windowWidth - 20

    const height = (boxWidth * 9) / 16 // Maintain a 16/9 aspect ratio.
    if (this.state.windowWidth >= 1080) {
      // In L screens, the height of the large preview box will be a constant.
      return 360
    }
    return height
  }
  getSmallVideoPreviewBoxHeight() {
    // As every section, this section has 10px padding from the left and from the right.
    // Moreover, the image preview box will take just 5/12 of the section's width.
    const boxWidth = ((this.state.windowWidth - 20) / 12) * 5
    const height = (boxWidth * 9) / 16
    if (this.state.windowWidth >= 1080) {
      // In L screens, the height of the small preview box will be a constant.
      return 170
    }
    return height
  }

  render() {
    const classes = this.props.classes
    return (
      <Grid
        container
        direction="row-reverse"
        alignItems='stretch'
      >
        <Grid
          container
          item
          className={classes.largeVideoPreviewBoxContainer}
          lg={6} md={12} sm={12}
        >
          <LargeVideoPreviewBox
            height={this.getLargeVideoPreviewBoxHeight()}
            videoDetails={this.props.playlist[0]}
            onVideoClicked={() => this.props.onVideoClicked(0)}
            showTitle={true}
          />
        </Grid>

        <Grid
          container
          item
          lg={6} md={12} sm={12}
        >
          <Grid item container className={classes.topRowContainer}>
            <VideoRowItem
              height={this.getSmallVideoPreviewBoxHeight()}
              videoDetails={this.props.playlist[1]}
              onVideoClicked={() => this.props.onVideoClicked(1)}
            />
          </Grid>
          <Grid item container className={classes.bottomRowContainer}>
            <VideoRowItem
              height={this.getSmallVideoPreviewBoxHeight()}
              videoDetails={this.props.playlist[2]}
              onVideoClicked={() => this.props.onVideoClicked(2)}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(useStyles)(SectionThreeItems)
